/**
 * @file 基于fixed的滚动置顶
 * @author liudaoyu
 */

import React, { Component, RefObject } from 'react';
import { debounce } from '@umu/umu-util';
import { $document, $window, isPassiveListenerSupported } from '@umu/umu-dom';

import './scrollFixed.scss';

interface IProps {
    cls?: string;
}

interface IState {
    isFixed: boolean;
    holderHieght: number;
}

export default class ScrollFixed extends Component<IProps, IState> {
    public observer: MutationObserver | null;
    public holderRef: RefObject<HTMLDivElement>;
    public contentRef: RefObject<HTMLDivElement>;
    constructor(props: IProps) {
        super(props);
        this.state = {
            isFixed: false,
            holderHieght: 0,
        };

        this.observer = null;
        this.holderRef = React.createRef();
        this.contentRef = React.createRef();

        this.bindEvent = this.bindEvent.bind(this);
        this.scrollEvent = debounce(this.scrollEvent.bind(this), 1000 / 60);
        this.load = this.load.bind(this);
    }

    public load() {
        const holderEl = this.contentRef.current;
        if (holderEl) {
            const eleHeight = holderEl.offsetHeight;
            const stateHeight = this.state.holderHieght;
            (eleHeight !== stateHeight) && this.setState({
                holderHieght: eleHeight,
            });
            if (!$window.MutationObserver || !!this.observer) {
                return;
            }
            const observer = this.observer = new $window.MutationObserver((mutationsList: any) => {
                for (const _mutation of mutationsList && eleHeight !== stateHeight) {
                    this.setState({
                        holderHieght: eleHeight,
                    });
                }
            });
            observer.observe(holderEl, { childList: true, subtree: true });
            $window.setTimeout(() => {
                observer.disconnect();
            }, 4000);
        }
    }

    public bindEvent() {
        const passive = isPassiveListenerSupported() ? { passive: true } : false;
        $window.addEventListener('scroll', this.scrollEvent, passive);
        $window.addEventListener('load', this.load, false);
    }

    public componentDidUpdate() {
        this.load();
    }

    public componentWillUnmount() {
        $window.removeEventListener('scroll', this.scrollEvent, false);
    }

    public scrollEvent() {
        this.setState({
            isFixed: this.hitTop(),
        });
    }

    public componentDidMount() {
        this.bindEvent();
        this.load();
    }

    public render() {
        const fixedCls = this.state.isFixed ? 'doc-fixed top filled bordered' : '';
        const isFixed = this.state.isFixed ? 'is-fixed' : '';
        return (
            <div className={`scroll-fixed ${isFixed}`} ref={this.holderRef}>
                <div className={`scroll-fixed-holder ${fixedCls} ${this.props.cls || ''}`} ref={this.contentRef}>{this.props.children}</div>
                <div className="children-holder" style={{ height: `${this.state.holderHieght}px` }}></div>
            </div>
        );
    }

    private hitTop() {
        let ret = false;
        const windowScrollTop =
            ($document.documentElement && $document.documentElement.scrollTop) || $document.body.scrollTop;

        const holderEl = this.holderRef.current;
        if (holderEl) {
            ret = windowScrollTop - holderEl.offsetTop >= 0;
        }

        return ret;
    }
}
